<template>
  <div>
    <!-- S I G N U P  T I T L E -->
    <div class="text-center">
      <p class="text-24 md:text-47 font-bold">I am using hello ivy...</p>
      <p class="text-20 text-grey-20">Let us know so we can set you up with the right tools.</p>
    </div>

    <!-- S I G N U P  T Y P E S -->
    <div class="md:flex justify-between my-30 md:my-50 md:-mx-40">
      <!-- P E R S O N A L -->
      <div
        class="md:w-1/2 md:mr-10 cursor-pointer rounded-10 anim-all"
        :class="selectedSignUpType === 'teams' ? 'border-3 border-brand shadow-signup' : 'border-3 border-transparent'"
        @click="select('teams')"
      >
        <div
          class="rounded-10 px-20 pb-20 pt-30 text-center anim-all"
          :class="selectedSignUpType === 'teams' ? 'border border-transparent' : 'border border-grey-10'"
        >
          <img :src="require(`@/assets/images/teams.svg`)" class="w-full px-25" alt="teams">
          <p class="font-bold mt-20 text-19">With my team</p>
          <p class="text-grey-275 mt-6 px-10">Communicate and collaborate with your team on any project.</p>
        </div>
      </div>

      <!-- T E A M S -->
      <div
        class="md:w-1/2 md:ml-10 mt-20 md:mt-0 cursor-pointer rounded-10 anim-all"
        :class="selectedSignUpType === 'personal' ? 'border-3 border-brand shadow-signup' : 'border-3 border-transparent'"
        @click="select('personal')"
      >
        <div
          class="rounded-10 px-20 pb-20 pt-30 text-center anim-all"
          :class="selectedSignUpType === 'personal' ? 'border border-transparent' : 'border border-grey-10'"
        >
          <img :src="require(`@/assets/images/personal.svg`)" class="w-full px-25" alt="personal">
          <p class="font-bold mt-20 text-19">Just for myself</p>
          <p class="text-grey-275 mt-6 px-10">Write, plan, take notes and organize your life.</p>
        </div>
      </div>
    </div>

    <!-- C O N T I N U E  B U T T O N -->
    <div class="flex justify-center mt-30">
      <ButtonModule
        :disabled="!selectedSignUpType"
        :class="selectedSignUpType ? 'bg-brand hover:bg-brand-hover' : 'bg-grey-750'"
        text="Continue"
        suffix="relative icon-arrow-right ml-10 mt-2 text-10 left-0 group-hover:left-7 anim-all"
        class="w-full justify-center  text-white rounded-10 py-16 group font-medium text-17"
        @click="changeType"
      />
    </div>
    <LoginModal ref="loginModalRef" :email="user.email" @on-login="onLogin" />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import LoginModal from '@/components/auth/LoginModal'

export default defineComponent({
  name: 'Step2',

  components: { ButtonModule, LoginModal },

  props: {
    hasAccount: String,
    modelValue: String,
    user: Object
  },

  emits: ['update:modelValue', 'next', 'nextToStep4'],

  setup (props, { emit }) {
    const selectedSignUpType = ref(props.modelValue)
    const loginModalRef = ref(null)

    function select (value) {
      if (props.hasAccount) return
      selectedSignUpType.value = value
    }

    function changeType () {
      if (props.hasAccount) return loginModalRef.value.open()
      emit('update:modelValue', selectedSignUpType.value)
      emit('next')
    }

    async function onLogin () {
      loginModalRef.value.close()
      emit('nextToStep4')
    }

    return {
      // refs
      loginModalRef,
      // data
      selectedSignUpType,
      // functions
      changeType,
      select,
      onLogin
    }
  }
})
</script>
